import * as types from "../ActionTypes/actionTypes.js";
import { CALL_API } from "../middleware/api";

export function getAssetLines() {
  const options = { headers: { "Content-Type": "application/json", Accept: "application/json" }, method: "GET" };

  return {
    [CALL_API]: {
      endpoint: "asset/getLines",
      authenticated: true,
      config: options,
      types: [types.GET_LINE_ASSETS_REQUEST, types.GET_LINE_ASSETS_SUCCESS, types.GET_LINE_ASSETS_FAILURE],
    },
  };
}
export function getAssetLinesWithSelf(criteria = { location: true, plannable: true }) {
  const options = {
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    method: "POST",
    body: JSON.stringify({ criteria }),
  };

  return {
    [CALL_API]: {
      endpoint: "asset/getLinesWithSelf",
      authenticated: true,
      config: options,
      types: [types.GET_LINE_ASSETS_WITH_SELF_REQUEST, types.GET_LINE_ASSETS_WITH_SELF_SUCCESS, types.GET_LINE_ASSETS_WITH_SELF_FAILURE],
    },
  };
}
export function getAssetTypesAsset(asset) {
  const options = { headers: { "Content-Type": "application/json", Accept: "application/json" }, method: "GET" };
  let assetObj = JSON.stringify({ assetType: asset.assetType, lineId: asset.lineId });
  return {
    [CALL_API]: {
      endpoint: "asset/getAssetTypesAsset/" + assetObj,
      authenticated: true,
      config: options,
      types: [types.GET_ASSETTYPES_ASSETS_REQUEST, types.GET_ASSETTYPES_ASSETS_SUCCESS, types.GET_ASSETTYPES_ASSETS_FAILURE],
    },
  };
}

export function getInspectableAssets() {
  const options = { headers: { "Content-Type": "application/json", Accept: "application/json" }, method: "GET" };
  return {
    [CALL_API]: {
      endpoint: "asset/getInspectableAssets",
      authenticated: true,
      config: options,
      types: [types.GET_INSPECTABLE_ASSETS_REQUEST, types.GET_INSPECTABLE_ASSETS_SUCCESS, types.GET_INSPECTABLE_ASSETS_FAILURE],
    },
  };
}

export function getAllInspectableAssets(fieldsToReturn) {
  const options = {
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    method: "GET",
  };
  let endpoint = "asset/getAllInspectableAssets";
  if (fieldsToReturn) {
    endpoint += "?fieldsToReturn=" + fieldsToReturn;
  }
  return {
    [CALL_API]: {
      endpoint: endpoint,
      authenticated: true,
      config: options,
      types: [types.GET_ALLINSPECTABLE_ASSETS_REQUEST, types.GET_ALLINSPECTABLE_ASSETS_SUCCESS, types.GET_ALLINSPECTABLE_ASSETS_FAILURE],
    },
  };
}

export function getBlueCardAssets(year) {
  const options = {
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    method: "GET",
  };
  let endpoint = "asset/getBlueCardAssets";
  if (year) {
    endpoint += "?year=" + year;
  }
  return {
    [CALL_API]: {
      endpoint: endpoint,
      authenticated: true,
      config: options,
      types: [types.GET_BLUECARDASSETS_REQUEST, types.GET_BLUECARDASSETS_SUCCESS, types.GET_BLUECARDASSETS_FAILURE],
    },
  };
}

export function getUnAssignedAsset() {
  const options = { headers: { "Content-Type": "application/json", Accept: "application/json" }, method: "GET" };
  return {
    [CALL_API]: {
      endpoint: "asset/getUnAssignedAssets",
      authenticated: true,
      config: options,
      types: [types.GET_UNASSIGNED_ASSETS_REQUEST, types.GET_UNASSIGNED_ASSETS_SUCCESS, types.GET_UNASSIGNED_ASSETS_FAILURE],
    },
  };
}

export function getAssetTree() {
  const options = { headers: { "Content-Type": "application/json", Accept: "application/json" }, method: "GET" };
  return {
    [CALL_API]: {
      endpoint: "asset/getAssetTree",
      authenticated: true,
      config: options,
      types: [types.GET_ASSET_TREE_REQUEST, types.GET_ASSET_TREE_SUCCESS, types.GET_ASSET_TREE_FAILURE],
    },
  };
}

export function getLocationAssignmentAssetTree() {
  const options = { headers: { "Content-Type": "application/json", Accept: "application/json" }, method: "GET" };
  return {
    [CALL_API]: {
      endpoint: "asset/getAssetTree",
      authenticated: true,
      config: options,
      types: [
        types.GET_LOCATION_ASSIGNMENT_ASSET_TREE_REQUEST,
        types.GET_LOCATION_ASSIGNMENT_ASSET_TREE_SUCCESS,
        types.GET_LOCATION_ASSIGNMENT_ASSET_TREE_FAILURE,
      ],
    },
  };
}

export function createMultipleAssets(assetsList) {
  const options = {
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    method: "POST",
    body: JSON.stringify({ assetsList }),
  };
  return {
    [CALL_API]: {
      endpoint: "asset/multiple",
      authenticated: true,
      config: options,
      types: [types.CREATE_MULTIPLE_ASSETS_REQUEST, types.CREATE_MULTIPLE_ASSETS_SUCCESS, types.CREATE_MULTIPLE_ASSETS_FAILURE],
    },
  };
}

export function updateAssetLocation(data) {
  let assetObj = JSON.stringify({ assetToUpdate: data.assetToUpdate, assetChildren: data.assetChildren, locationInfo: data.locationInfo });
  const options = {
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    method: "PUT",
    body: assetObj,
  };
  return {
    [CALL_API]: {
      endpoint: "asset/moveAsset",
      authenticated: true,
      config: options,
      types: [types.MOVE_ASSET_LOCATION_REQUEST, types.MOVE_ASSET_LOCATION_SUCCESS, types.MOVE_ASSET_LOCATION_FAILURE],
    },
  };
}

export function getPlannedAssets() {
  const options = { headers: { "Content-Type": "application/json", Accept: "application/json" }, method: "GET" };
  return {
    [CALL_API]: {
      endpoint: "asset/getPlannedAssets",
      authenticated: true,
      config: options,
      types: [types.GET_PLANNED_ASSETS_REQUEST, types.GET_PLANNED_ASSETS_SUCCESS, types.GET_PLANNED_ASSETS_FAILURE],
    },
  };
}



// WEBPACK FOOTER //
// ./src/reduxRelated/actions/assetHelperAction.js